

export class DesignationUpdateInput implements IDesignationUpdateInput {
    /** The auto-generated id of the designation master */
    designationId!: number;
    /** The designation name with 255 character limit */
    designationName!: string;

    constructor(data?: IDesignationUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designationId = _data["designationId"];
            this.designationName = _data["designationName"];
        }
    }

    static fromJS(data: any): DesignationUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DesignationUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designationId"] = this.designationId;
        data["designationName"] = this.designationName;
        return data; 
    }
}

export interface IDesignationUpdateInput {
    /** The auto-generated id of the designation master */
    designationId: number;
    /** The designation name with 255 character limit */
    designationName: string;
}

